import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG } from '../lib/angular/injection-tokens';
import { IAppConfig } from '../lib/config/app-config';
import { ScormEntry } from '../_models/ScormEntry';
import { ScormSession } from '../_models/ScormSession';
import { AppConstants } from '../constants/constants';

declare var API: any;

@Injectable({
  providedIn: 'root'
})
export class ScormReceiverService {

  private baseUrl: string = this.config.protectedResourceEndpoint;

  constructor(private http: HttpClient, @Inject(APP_CONFIG) private config: IAppConfig) {
  }

  getScormSessionById$(): Observable<ScormSession> {
    return null;
  }

  createSessionByObjectId$(objectId: string): Observable<ScormSession> {
    return this.http.get<ScormSession>(this.baseUrl + "ScormSession/userSession/" + objectId);
  }

  getSessionByObjectId$(objectId: string): Observable<ScormSession> {
    return this.http.get<ScormSession>(this.baseUrl + "ScormSession/review/" + objectId);
  }

  getSessionByLearnerIdAndObjectId$(learnerId: number, objectId: string): Observable<ScormSession> {
    let params: HttpParams = new HttpParams();
    params = params.append(AppConstants.LEARNER_ID, String(learnerId));
    params = params.append(AppConstants.OBJECT_ID, String(objectId));
    return this.http.get<ScormSession>(this.baseUrl + "ScormSession/learner/review/", {params});
  }

  getWrittenAssignSessionByLearnerIdAndObjectId$(learnerId: number, objectId: string): Observable<ScormSession> {
    let params: HttpParams = new HttpParams();
    params = params.append(AppConstants.LEARNER_ID, String(learnerId));
    params = params.append(AppConstants.OBJECT_ID, String(objectId));
    return this.http.get<ScormSession>(this.baseUrl + "ScormSession/learner/reviewwrittenassignment/", {params});
  }

  saveSessionState$(session: ScormSession): Observable<ScormEntry[]> {
    session.scormEntries.forEach(entry => {
      entry.scormSessionId = session.id;
      entry.learnerCourseLogId = session.learnerCourseLogId;
    })

    if (!session.open) {
      return null;
    }

    return this.http.put<ScormEntry[]>(this.baseUrl + "ScormEntry/UpdateBulkData", session.scormEntries);
  }

  GetCourseStatusByUserProfileId$(): Observable<string[]> {
    return this.http.get<string[]>(this.baseUrl + 'ScormSession/courselist');
  }

  deleteSessionById$(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + AppConstants.SCORM_SESSION + AppConstants.SLASH + id);
  }

  public addScormSession$(data: ScormSession): Observable<ScormSession> {
    return this.http.post<ScormSession>(this.baseUrl + AppConstants.SCORM_SESSION, data);
  }
}
